"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IcUnsplash = (props) => ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M10.25 1.98828H5.75V5.36328H10.25V1.98828Z" }), (0, jsx_runtime_1.jsx)("path", { d: "M10.25 10.6368H5.75V7.26181H2V14.0118H14V7.26181H10.25V10.6368Z" })] })));
exports.default = IcUnsplash;
